export default {
    initEnvironment: () => {
        return {
            url: '/testbench/initialize',
            method: 'GET'
        };
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/api.js